import React from 'react';
import { Link } from 'react-router-dom';

import Alert from 'react-bootstrap/Alert';
import { Eye } from 'react-feather';

import K2Api from 'lib/ajax/K2Api';
import Loader from 'components/Loader';
import AdvancedTable from 'components/LM/common/AdvancedTable';
import { useK2Loader } from 'hooks/useK2Loader';
import Breadcrumb from "components/LM/common/Breadcrumb";

const TABLE_COLUMNS = [
	{ name: "id", alias: "ID" },
	{ name: "date", alias: "Date" },
	{ name: "name", alias: "Name" },
	{ name: "requester", alias: "Requester" },
	{ name: "status", alias: "Status" },
	{ name: "total", alias: "Total" },
	{ name: "pending", alias: "Pending" },
	{ name: "working", alias: "Working" },
	{ name: "done", alias: "Done" },
	{ name: "failed", alias: "Failed" },
	{ name: 'details_link', alias: '' }
];

const DEFAULT_PARAMS = { from: 0, size: 20 };
const k2Api = new K2Api();

function OverallStatus() {
	const [loading, response, error] = useK2Loader("/voices/batch-request", { params: DEFAULT_PARAMS });

	if (loading) return <Loader />;
	if (error) return <Alert variant="danger">{error.toString()}</Alert>
	return (<>
		{breadcrumbPage()}
		<AdvancedTable
			columns={TABLE_COLUMNS}
			onSearch={params => loadStatuses(params)}
			onResults={response => processResponse(response)}
			data={processResponse(response)}
		/>
	</>)
}

async function loadStatuses({ page, pageSize }) {
	const from = (page - 1) * pageSize;
	const response = await k2Api.get(`/voices/batch-request`, { params: { from, size: pageSize } });
	return response.data;
}

function processResponse(response) {
	const total = response.total;
	const rows = response.results.map(result => {
		return {
			id: result.id,
			date: result.inserted_at,
			name: result.name,
			requester: result.requester ?? "-",
			status: result.status,
			total: `${result.summary.pending + result.summary.working + result.summary.finished + result.summary.failed}`,
			pending: `${result.summary.pending}`,
			working: `${result.summary.working}`,
			done: `${result.summary.finished}`,
			failed: `${result.summary.failed}`,
			details_link: <Link to={`/voices/new-import/status/${result.id}`}>
				<Eye width="14" height="14" />
			</Link>
		}
	});
	return { total, rows };
}

function breadcrumbPage() {
	const items = [
		'Voices',
		<a href="/voices/new-import">New Mass Import</a>,
		'Import Status'
	];
	return <Breadcrumb items={items} />
}

export default OverallStatus;
